import { useCallback as e, useEffect as t, useRef as n, useState as r } from "react";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var s = Object.defineProperty, c = (e, t) => {
	let n = {};
	for (var r in e) s(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || s(n, Symbol.toStringTag, { value: "Module" }), n;
}, l = [
	{
		w: 567,
		label: "xs"
	},
	{
		w: 768,
		label: "sm"
	},
	{
		w: 992,
		label: "md"
	},
	{
		w: 1200,
		label: "lg"
	},
	{
		w: 9999,
		label: "xl"
	}
], u = [{
	label: "lg",
	info: {
		w: 24,
		h: 3
	}
}], d = [{
	title: "高级布局画布",
	snapshotText: "RGL",
	description: "高级布局画布",
	schema: { props: { breakpoints: l } }
}], f = [{
	title: "高级布局容器",
	snapshotText: "RGEL",
	description: "高级布局容器",
	schema: { props: { responsive: [...u] } }
}], p = typeof global == "object" && global && global.Object === Object && global, m = typeof self == "object" && self && self.Object === Object && self, h = p || m || Function("return this")(), g = h.Symbol, _ = Object.prototype, v = _.hasOwnProperty, y = _.toString, b = g ? g.toStringTag : void 0;
function x(e) {
	var t = v.call(e, b), n = e[b];
	try {
		e[b] = void 0;
		var r = !0;
	} catch {}
	var i = y.call(e);
	return r && (t ? e[b] = n : delete e[b]), i;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_objectToString.js
var S = Object.prototype.toString;
function ee(e) {
	return S.call(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseGetTag.js
var C = "[object Null]", w = "[object Undefined]", T = g ? g.toStringTag : void 0;
function te(e) {
	return e == null ? e === void 0 ? w : C : T && T in Object(e) ? x(e) : ee(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isObjectLike.js
function E(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isSymbol.js
var D = "[object Symbol]";
function O(e) {
	return typeof e == "symbol" || E(e) && te(e) == D;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_trimmedEndIndex.js
var k = /\s/;
function A(e) {
	for (var t = e.length; t-- && k.test(e.charAt(t)););
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseTrim.js
var ne = /^\s+/;
function re(e) {
	return e && e.slice(0, A(e) + 1).replace(ne, "");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isObject.js
function j(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/toNumber.js
var M = NaN, N = /^[-+]0x[0-9a-f]+$/i, P = /^0b[01]+$/i, F = /^0o[0-7]+$/i, I = parseInt;
function L(e) {
	if (typeof e == "number") return e;
	if (O(e)) return M;
	if (j(e)) {
		var t = typeof e.valueOf == "function" ? e.valueOf() : e;
		e = j(t) ? t + "" : t;
	}
	if (typeof e != "string") return e === 0 ? e : +e;
	e = re(e);
	var n = P.test(e);
	return n || F.test(e) ? I(e.slice(2), n ? 2 : 8) : N.test(e) ? M : +e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/now.js
var R = function() {
	return h.Date.now();
}, z = "Expected a function", B = Math.max, V = Math.min;
function H(e, t, n) {
	var r, i, a, o, s, c, l = 0, u = !1, d = !1, f = !0;
	if (typeof e != "function") throw TypeError(z);
	t = L(t) || 0, j(n) && (u = !!n.leading, d = "maxWait" in n, a = d ? B(L(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
	function p(t) {
		var n = r, a = i;
		return r = i = void 0, l = t, o = e.apply(a, n), o;
	}
	function m(e) {
		return l = e, s = setTimeout(_, t), u ? p(e) : o;
	}
	function h(e) {
		var n = e - c, r = e - l, i = t - n;
		return d ? V(i, a - r) : i;
	}
	function g(e) {
		var n = e - c, r = e - l;
		return c === void 0 || n >= t || n < 0 || d && r >= a;
	}
	function _() {
		var e = R();
		if (g(e)) return v(e);
		s = setTimeout(_, h(e));
	}
	function v(e) {
		return s = void 0, f && r ? p(e) : (r = i = void 0, o);
	}
	function y() {
		s !== void 0 && clearTimeout(s), l = 0, r = c = i = s = void 0;
	}
	function b() {
		return s === void 0 ? o : v(R());
	}
	function x() {
		var e = R(), n = g(e);
		if (r = arguments, i = this, c = e, n) {
			if (s === void 0) return m(c);
			if (d) return clearTimeout(s), s = setTimeout(_, t), p(c);
		}
		return s === void 0 && (s = setTimeout(_, t)), o;
	}
	return x.cancel = y, x.flush = b, x;
}
//#endregion
//#region src/components/ReactGridLayout/item.meta.tsx
var U = /* @__PURE__ */ c({
	ReactGridItemMeta: () => G,
	default: () => K
}), W = {}, G = {
	componentName: "GridItem",
	title: "高级布局容器",
	category: "高级布局",
	groupName: "内置组件",
	props: [{
		name: "responsive",
		title: "Responsive",
		setters: [{
			componentName: "ArraySetter",
			initialValue: l,
			props: {
				collapse: { open: !0 },
				item: {
					initialValue: {
						w: 0,
						label: "customSize"
					},
					setters: [{
						componentName: "ShapeSetter",
						initialValue: {
							with: 0,
							c: 0
						},
						props: {
							collapse: { open: !0 },
							elements: [{
								name: "label",
								title: "label",
								setters: [{
									componentName: "StringSetter",
									props: { disabled: !0 }
								}],
								valueType: "number"
							}, {
								name: "info",
								title: "info",
								valueType: "object",
								setters: [{
									componentName: "ShapeSetter",
									initialValue: {
										with: 0,
										label: ""
									},
									props: {
										collapse: !1,
										elements: [
											{
												name: "w",
												title: "width",
												setters: ["NumberSetter", "ExpressionSetter"],
												valueType: "number"
											},
											{
												name: "h",
												title: "height",
												setters: ["NumberSetter", "ExpressionSetter"],
												valueType: "number"
											},
											{
												name: "x",
												title: "offsetX",
												setters: ["NumberSetter", "ExpressionSetter"],
												valueType: "number"
											},
											{
												name: "y",
												title: "offsetY",
												setters: ["NumberSetter", "ExpressionSetter"],
												valueType: "number"
											}
										]
									}
								}]
							}]
						}
					}]
				}
			}
		}],
		valueType: "number"
	}],
	isContainer: !0,
	npm: {
		name: "GridItem",
		package: "@chamn/material",
		version: "0.12.7",
		destructuring: !0,
		exportName: "GridItem"
	},
	disableEditorDragDom: !0,
	advanceCustom: {
		rightPanel: { advanceOptions: {
			render: !1,
			loop: !1
		} },
		autoGetDom: !1,
		toolbarViewRender: ({ node: e, context: n, toolBarItemList: i }) => {
			i.splice(1, 1);
			let [s, c] = r({
				label: "",
				w: 0,
				h: 0,
				x: 0,
				y: 0
			}), l = H(async () => {
				let t = W[e.id];
				if (!t) return;
				let n = t.current?.getCurrentPosAndSizeInfo();
				c({
					label: n.label,
					x: n.info?.x,
					y: n.info?.y,
					w: n.info?.w,
					h: n.info?.h
				});
			}, 100), u = async () => {
				e.onChange(l), ((await n.pluginManager.get("Designer"))?.export.getDesignerWindow())?.addEventListener("resize", l), window?.addEventListener("resize", l);
			}, d = async () => {
				((await n.pluginManager.get("Designer"))?.export.getDesignerWindow())?.removeEventListener("resize", l), window.removeEventListener("resize", l);
			};
			return t(() => (l(), u(), () => {
				d();
			}), []), /* @__PURE__ */ o("div", {
				style: {
					display: "flex",
					float: "right",
					zIndex: 999,
					pointerEvents: "all"
				},
				children: [/* @__PURE__ */ o("div", {
					style: {
						background: "white",
						marginRight: "5px",
						fontSize: "12px",
						padding: "0 10px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					},
					children: [
						/* @__PURE__ */ a("b", {
							style: {
								paddingRight: "2px",
								color: "red"
							},
							children: s.label
						}),
						"| w: ",
						s.w,
						" | h: ",
						s.h,
						" | x: ",
						s.x,
						" | y: ",
						s.y
					]
				}), i]
			});
		},
		onDragStart: async () => !1,
		wrapComponent: (e, t) => (n) => /* @__PURE__ */ a(e, {
			...n,
			...t,
			dev: !0,
			onGetRef: (e) => {
				W[t.node.id] = e;
			}
		}),
		canDropNode: async (e, t) => {
			let { dropNode: n } = t;
			return n ? n.value.componentName === "GridLayout" : !1;
		},
		onCopy: async (e) => {
			let t = e.getPlainProps();
			return t.responsive = t.responsive.map((e) => ({
				...e,
				x: "",
				y: ""
			})), e.updateValue({ props: t }), !0;
		},
		onNewAdd: async (e, t) => {
			let { dropNode: n } = t;
			return n ? n.value.componentName === "GridLayout" : !1;
		}
	},
	snippets: f
}, K = [G], q = (e) => {
	let { targetComp: t, ...r } = e, i = n(), o = (t) => {
		t.on("change", (t) => {
			let { detail: n } = t, r = e.subWin.innerWidth, i = l.find((e) => e.w >= r);
			n.forEach((t) => {
				let n = t.el.getAttribute("data-grid-id"), r = e.ctx.engine.pageModel.getNode(String(n));
				if (r) {
					let e = r.getPlainProps(), n = e.responsive, a = n.find((e) => e.label === i.label);
					a || (a = {
						label: i.label,
						info: {}
					}, n.push(a)), a.info = {
						x: t.x,
						y: t.y,
						w: t.w,
						h: t.h
					}, r.updateValue({ props: e });
				}
			});
		});
	};
	return /* @__PURE__ */ a(t, {
		...r,
		animate: !0,
		staticGrid: !1,
		subWin: e.subWin,
		onMount: (e) => {
			i.current = e, o(e), r.onMount?.(e);
		}
	});
}, J = /* @__PURE__ */ c({
	ReactGridLayoutMeta: () => Y,
	default: () => ie
}), Y = {
	componentName: "GridLayout",
	title: "高级布局画布",
	props: [{
		name: "breakpoints",
		title: "Breakpoints",
		setters: [{
			componentName: "ArraySetter",
			initialValue: l,
			props: {
				collapse: { open: !0 },
				item: {
					initialValue: {
						w: 0,
						label: ""
					},
					setters: [{
						componentName: "ShapeSetter",
						initialValue: {
							with: 0,
							c: 0
						},
						props: {
							collapse: { open: !0 },
							elements: [{
								name: "label",
								title: "label",
								setters: ["StringSetter"],
								valueType: "string"
							}, {
								name: "w",
								title: "width",
								setters: [{
									componentName: "NumberSetter",
									props: { suffix: "px" }
								}],
								valueType: "number"
							}]
						}
					}]
				}
			}
		}],
		valueType: "array"
	}],
	isContainer: !0,
	category: "高级布局",
	groupName: "内置组件",
	npm: {
		name: "GridLayout",
		package: "@chamn/material",
		version: "0.12.7",
		destructuring: !0,
		exportName: "GridLayout"
	},
	snippets: d,
	advanceCustom: {
		autoGetDom: !1,
		wrapComponent: (o, s) => (c) => {
			let [l, u] = r(), d = n();
			t(() => {
				s.ctx.pluginManager.onPluginReadyOk("Designer").then((e) => {
					d.current = e;
					let t = e.export.getDesignerWindow();
					u(t);
				});
			}, []);
			let f = e((e) => {
				e.on("dragstart", () => {
					d.current?.export.getLayoutRef().current?.banSelectNode();
				}), e.on("dragstop", (e) => {
					setTimeout(() => {
						d.current?.export.getLayoutRef().current?.recoverSelectNode();
						let t = e.target?.getAttribute("data-grid-id");
						d.current?.export.getLayoutRef().current?.selectNode(t);
					}, 0);
				});
			}, []);
			return l ? /* @__PURE__ */ a(q, {
				...c,
				...s,
				targetComp: o,
				subWin: l,
				onMount: f
			}) : /* @__PURE__ */ a(i, {});
		},
		rightPanel: { visual: !1 }
	}
}, ie = [Y], X = /* #__PURE__ */ Object.assign({
	"./components/ReactGridLayout/item.meta.tsx": U,
	"./components/ReactGridLayout/meta.tsx": J
}), Z = [];
Object.keys(X).forEach((e) => {
	let t = X[e];
	Z.push(...t.default);
});
var Q = /* #__PURE__ */ Object.assign({}), $ = {};
Object.keys(Q).forEach((e) => {
	let t = Q[e];
	$ = {
		...$,
		...t
	};
});
var ae = {
	meta: Z,
	setter: $,
	version: "0.12.7",
	package: "@chamn/material",
	globalName: "ChamnCommonComponents"
};
//#endregion
export { ae as default };

//# sourceMappingURL=meta.es.js.map